module.exports = __webpack_public_path__ + "img/borrower_benefit_scoreandmore.6a6c8c05.jpg";